import React, { FC } from "react";

import { KButtonAction, KButtonProps, useFontAwesomeIconSize } from "@keepeek/refront-components";
import { Badge } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { KIcon } from "../common/KIcon";

type ShowAttachmentButton = {
  attachmentsCount: number;
} & KButtonProps;

const ShowAttachmentButton: FC<React.PropsWithChildren<ShowAttachmentButton>> = function ({
  className,
  attachmentsCount,
  onClick,
  sx,
}) {
  const { t } = useTranslation();
  const fontAwesomeIconSizeForActions = useFontAwesomeIconSize({
    belowSmIconName: "",
    aboveSmIconName: "",
  });

  return (
    <KButtonAction
      className={clsx("ShowAttachmentButton", className)}
      onClick={onClick}
      aria-label={t("media-detail.action.show-attachment.label")}
      title={t("media-detail.action.show-attachment.label")}
      sx={{
        ...sx,
      }}
    >
      <Badge
        sx={{
          "& .MuiBadge-badge": {
            right: "-12px",
            top: "-4px",
          },
        }}
        max={99}
        showZero
        badgeContent={attachmentsCount}
      >
        <KIcon className={`fa-paperclip fa-fw ${fontAwesomeIconSizeForActions}`} />
      </Badge>
    </KButtonAction>
  );
};

export default ShowAttachmentButton;
